'use strict';

import { data } from "jquery";

class DevicesNewController {
  constructor($q,
              $scope,
              $filter,
              $state,
              $window,
              utils,
              config,
              DevicesService,
              LocationsService,
              I18nService,
              ToastsService) {

    const $t = $filter('translate');
    const deviceIconFilter = $filter('deviceIcon');
    const orderBy = $filter('orderBy');
    const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';
    const ALL_ORGS_LOCAL_STORAGE_KEY = 'Organizations-All';
    const SELECTED_LOCATION_LOCAL_STORAGE_KEY = 'Selected-Location';
    const DEFAULT_BRAND = 'default';
    const PAIRING_TYPES = config.getConfigByKey('devicePairingTypes');
    const lastLocation = utils.getStorageItem(SELECTED_LOCATION_LOCAL_STORAGE_KEY);

    const selectedOrg = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);
    const availableOrgs = utils.getStorageItem(ALL_ORGS_LOCAL_STORAGE_KEY);

    $scope.locale = I18nService.getLocale();
    $scope.sortBy = 'name.' + $scope.locale.code;
    $scope.device = {};

    // Detect current organization brand
    if (selectedOrg && !selectedOrg.brand) {
      selectedOrg.brand = utils.getBrandName(selectedOrg.id, availableOrgs);
    }

    $scope.tabs = [
      {
        id: 'info',
        name: $t('devices.new.tabs.info'),
        icon: 'far fa-file-alt'
      },
      {
        id: 'deviceModel',
        name: $t('devices.new.tabs.deviceModel'),
        icon: 'far fa-microchip'
      },
      {
        id: 'stories',
        name: $t('devices.new.tabs.stories'),
        icon: 'far fa-box-open'
      },
      {
        id: 'files',
        name: $t('devices.edit.tabs.files'),
        icon: 'far fa-folders'
      }
    ];

    angular.extend($scope, {
      searchLocations: searchLocations,
      chooseLocation: chooseLocation,
      generateAddress: generateAddress,
      chooseDeviceModel: chooseDeviceModel,
      onDeviceModelsSearch: onDeviceModelsSearch,
      bindDeviceToLocation: bindDeviceToLocation,
      navigateBack: navigateBack,
      gotoPrevStep: gotoPrevStep,
      changeLocation: changeLocation,
      getPairingType: getPairingType,
      getDeviceIcon: getDeviceIcon,
      getDeviceType: getDeviceType,

      // Files
      downloadFile: downloadFile
    });

    init();

    function init() {
      $scope.selectedLocationId = $state.params && $state.params.locationId;
      $scope.selectedDeviceModelId = $state.params && $state.params.deviceModelId;

      // Set selected location
      $scope.selectedLocation = $scope.selectedLocationId && lastLocation && lastLocation.id == $scope.selectedLocationId
        ? lastLocation
        : undefined;

      // 0 - initial
      // 1 - select device model
      // 2 - Setup device (device id, name, etc.)
      $scope.step = 0;

      $scope.activeTab = $scope.tabs[0].id;

      initForms();

      $q.all([initDeviceModels(), DevicesService.getDeviceTypes()])
        .then(result => {
          if ($scope.selectedDeviceModelId) {
            $scope.selectedDeviceModelCategory = $scope.deviceModelsCategoriesFlat
              .find(c => c.models && c.models.some(m => m.id === $scope.selectedDeviceModelId));

            if (!$scope.selectedDeviceModelCategory) {
              $scope.selectedDeviceModelId = void 0;
              return;
            }

            $scope.selectedDeviceModelCategoryId = $scope.selectedDeviceModelCategory.id;
            $scope.selectedDeviceModel = $scope.selectedDeviceModelCategory.models.find(m => m.id === $scope.selectedDeviceModelId);
            $scope.selectedDeviceModelId = $scope.selectedDeviceModel.id;
          }

          $scope.deviceTypes = result[1].deviceTypes || [];
          gotoNextStep();
        });
    }

    function initForms() {
      // Init device info form
      $('#form-device').form({
        inline: true,
        fields: {
          deviceId: {
            rules: [
              {
                type: 'empty',
                prompt: $t('prompt.device.id.empty')
              }
            ]
          },
          deviceDesc: {
            rules: [
              {
                type: 'empty',
                prompt: $t('prompt.device.desc.empty')
              }
            ]
          }
        }
      });
    }

    function gotoNextStep() {
      if (!$scope.selectedDeviceModelCategoryId || !$scope.selectedDeviceModelId) {
        $scope.step = 1;
      } else {
        $scope.step = 2;

        if ($scope.selectedDeviceModel) {

          // Parse lookup parameters
          if ($scope.selectedDeviceModel.lookupParams) {
            let deviceTypesArr = $scope.selectedDeviceModel.lookupParams.map(el => {
              return el.deviceType && el.deviceType;
            });
            $scope.selectedDeviceModel.deviceTypes = deviceTypesArr.join(', ');

            // Process related device types
            $scope.selectedDeviceModel.lookupParams.map(el => {
              if (el.deviceType) {
                el.name = getDeviceType(el.deviceType).name + ' (' + el.deviceType + ')';
              }
            });

          }

          // Dependency device types as proxy devices
          $scope.selectedDeviceModel.dependencyDeviceTypesString = $scope.selectedDeviceModel.dependencyDeviceTypes.join(', ');
          if ($scope.selectedLocation) {
            getProxyDevices($scope.selectedLocation);
          }
        }
      }
    }

    function gotoPrevStep() {
      $scope.step = 1;
      $scope.selectedDeviceModelCategoryId = void 0;
      $scope.selectedDeviceModelCategory = void 0;
      $scope.selectedDeviceModelId = void 0;
      $scope.selectedDeviceModel = void 0;
      $state.go($state.current.name, { deviceModelId: void 0 }, {
        notify: false,
        location: 'replace',
        inherit: true
      });
    }

    /* Enables search locations */
    function changeLocation() {
      $scope.allowSearch = true;
    }

    function navigateBack() {
      // $rootScope.$emit('refreshChooseMenuEvent', 'locations');
      $window.history.back();
    }

    function searchLocations() {
      if (!$scope.searchLocationBy) {
        return;
      }
      $scope.locationsLoading = true;
      return LocationsService
        .getLocations(selectedOrg.id, {
          searchBy: $scope.searchLocationBy + '*',
          getTags: false,
          tree: false,
          limit: 100
        })
        .then((data) => {
          $scope.locationsLoading = false;
          $scope.locations = data.locations || [];
        }, (err) => {
          utils.handleApiError(err);
          $scope.locationsLoading = false;
        });
    }

    function chooseLocation(location) {
      if (!location || !location.id) {
        return;
      }

      $scope.allowSearch = false;
      $scope.selectedLocationId = location.id;
      $scope.selectedLocation = location;

      getProxyDevices($scope.selectedLocation);

      $state.go($state.current.name, { locationId: $scope.selectedLocationId }, {
        notify: false,
        location: 'replace',
        inherit: true
      });
    }

    function getProxyDevices(location) {
      if (!location || $scope.selectedDeviceModel && (!$scope.selectedDeviceModel.dependencyDeviceTypes || $scope.selectedDeviceModel.dependencyDeviceTypes.length === 0)) {
        return;
      }

      DevicesService.getDevicesByParams(location.organizationId,{
        locationId: location.id,
        deviceType: $scope.selectedDeviceModel.dependencyDeviceTypes,
      }).then((data) => {
          $scope.proxyDevices = data.devices || [];
        }, (err) => {
          utils.handleApiError(err);
          $scope.proxyDevices = [];
        });
    }

    function generateAddress(location) {
      let address = utils.generateAddress(location);
      return address ? address : $t('common.unknown-address');
    }

    function initDeviceModels() {
      $scope.deviceModelsLoading = true;
      return DevicesService.getDeviceModels({
        brand: selectedOrg.brand || DEFAULT_BRAND,
        lang: $scope.locale.code
      })
        .then((data) => {
          $scope.deviceModelsLoading = false;
          let categories = angular.copy(data.categories);
          $scope.deviceModelsCategoriesFlat = angular.copy(categories);

          // Build parent-to-children relation from child-to-parent relation
          categories
            .forEach(c => c.children = orderBy(categories.filter(child => child.parentId === c.id), 'sortId'));

          // filter hidden or empty categories
          categories = categories
            .filter(c => !(c.hidden || ((!c.children || c.children.length === 0) && (!c.models || c.models.length === 0))));

          // sort models and categories
          categories.forEach(c => {
            if (c.models) {
              c.models = orderBy(c.models, 'sortId');
            }
          });
          categories = orderBy(categories, 'sortId');

          categories.forEach(c => {
            if (!c.parentId || !c.models) {
              return;
            }
            let rootCat = c;
            do {
              rootCat = categories.find(cat => cat.id === rootCat.parentId);
            } while (rootCat && rootCat.parentId && categories.some(cat => cat.id === rootCat.parentId));

            if (!rootCat) {
              return;
            }
            c.models.forEach(m => m.category = c);
            rootCat.allModels = (rootCat.allModels || []).concat(c.models);
            rootCat.filteredModels = rootCat.allModels.slice();
          });

          categories = categories
            .filter(c => !c.parentId || !categories.some(cat => cat.id === c.parentId));

          // Handle root categories with no children categories but with some models
          // Put it in generic root category named Miscellaneous
          // ---------
          const miscCategory = {
            id: 'Miscellaneous',
            hidden: false,
            name: { en: 'Miscellaneous' },
            search: 'miscellaneous,other,others',
            sortId: 0,
            allModels: [],
            filteredModels: [],
          };

          categories
            .filter(c => c.models && c.models.length > 0 && !c.parentId && !c.allModels)
            .forEach(c => {
              c.parentId = miscCategory.id;
              c.models.forEach(m => m.category = c);
              miscCategory.allModels = miscCategory.allModels.concat(c.models);
              miscCategory.filteredModels = miscCategory.allModels.slice();
            });

          if (miscCategory.allModels.length > 0) {
            categories.push(miscCategory);
          }
          // ---------

          $scope.deviceModelsCategories = categories;
        }, (err) => {
          utils.handleApiError(err);
          $scope.deviceModelsLoading = false;
        });
    }

    function onDeviceModelsSearch(text) {
      text = text ? text.toLowerCase() : void 0;
      let locale = $scope.locale.code;
      $scope.deviceModelsCategories.forEach(cat => {
        if (!cat.allModels) {
          cat.filteredModels = void 0;
          return;
        }
        if (!text) {
          cat.filteredModels = cat.allModels.slice();
          return;
        }
        cat.filteredModels = cat.allModels.filter(m => {
          return [
            m.name ? m.name[locale] : null,
            m.desc ? m.desc[locale] : null,
            m.manufacturer ? m.manufacturer[locale] : null,
            m.id,
            m.search
          ].some(str => str && str.toLowerCase().includes(text));
        });
      });

      $scope.noDeviceModelsFound = $scope.deviceModelsCategories.every(cat => !cat.filteredModels || !cat.filteredModels.length);
    }

    function chooseDeviceModel(deviceModel, deviceModelCategory, $event) {
      if ($event) {
        $event.stopPropagation();
      }
      if (!deviceModel || !deviceModel.id || !deviceModelCategory || !deviceModelCategory.id) {
        return;
      }
      $scope.selectedDeviceModelCategoryId = deviceModelCategory.id;
      $scope.selectedDeviceModelCategory = deviceModelCategory;
      $scope.selectedDeviceModelId = deviceModel.id;
      $scope.selectedDeviceModel = deviceModel;
      $state.go($state.current.name, { deviceModelId: $scope.selectedDeviceModelId }, {
        notify: false,
        location: 'replace',
        inherit: true
      });
      gotoNextStep();
    }

    function getDeviceType(deviceTypeId) {
      if (!$scope.deviceTypes || !$scope.deviceTypes.length) {
        return $t('common.unknown');
      }
      return $scope.deviceTypes.find(el => {
        return el.id == deviceTypeId;
      });
    }

    function getPairingType() {
      if ($scope.selectedDeviceModel && $scope.selectedDeviceModel.pairingType) {
        let result = PAIRING_TYPES.find(el => {
          return el.id == $scope.selectedDeviceModel.pairingType;
        });
        return $t(result.name);
      }
      return;
    }

    function bindDeviceToLocation() {
      $('#form-device').form('validate form');
      if (!$('#form-device').form('is valid') || $scope.deviceLoading || !$scope.device.id || !$scope.device.desc || !$scope.selectedLocationId) {
        if ($scope.selectedDeviceModel.dependencyDeviceTypes && $scope.selectedDeviceModel.dependencyDeviceTypes.length > 0 && !$scope.selectedProxyId) {
          $scope.activeTab = 'info';
          return;
        }

        $scope.activeTab = 'info';
        return;
      }

      $scope.deviceLoading = true;

      let params = {
        locationId: parseInt($scope.selectedLocationId),
        deviceId: $scope.device.id,
        desc: $scope.device.desc
      };

      // Add proxy device
      if ($scope.selectedDeviceModel.dependencyDeviceTypes && $scope.selectedDeviceModel.dependencyDeviceTypes.length > 0 && $scope.selectedProxyId) {
        params.proxyId = $scope.selectedProxyId;
      }

      if ($scope.selectedDeviceType) {
        params.deviceType = $scope.selectedDeviceType.deviceType;
      }

      return DevicesService.registerDevice({}, params)
        .then(() => {
          ToastsService.success(null, $t('common.create-device-success'));
          const SELECTED_LOCATION_LOCAL_STORAGE_KEY = 'Selected-Location';
          utils.setStorageItem(SELECTED_LOCATION_LOCAL_STORAGE_KEY, $scope.selectedLocation);
          $state.go('main.locations.edit', {
            tab: 'devices',
            from: 'devices',
            locationId: $scope.selectedLocationId
          });
        }, (err) => {
          $scope.deviceLoading = false;
          utils.handleApiError(err);
        });
    }

    function getDeviceIcon(deviceModel, category, isLight) {
      if (!deviceModel) {
        return;
      }
      let namespace = isLight ? 'l' : 'r';
      let icon;
      if (deviceModel.icon) {
        icon = deviceModel.icon;
      } else if (deviceModel.category && deviceModel.category.icon) {
        icon = deviceModel.category.icon;
      } else if (category && category.icon) {
        icon = category.icon;
      }
      if (!icon) {
        icon = 'satellite-dish';
      }
      return deviceIconFilter(icon, namespace);
    }

    function downloadFile(url) {
      return utils.downloadFile(url);
    }

  }
}

export default angular
  .module('main.newDevices.controller', [])
  .controller('DevicesNewController', DevicesNewController)
  .name;
